<template>
  <div>
    <b-card>
      <b-card-header>
        <div class="d-flex justify-content-between w-100">
          <h5>{{ $t('settings.customerType.description') }}</h5>
          <b-button
            variant="primary"
            class="mb-2"
            @click="openModal('create')"
          >
            {{ $t('settings.customerType.actions.add_attribute') }}
          </b-button>
        </div>
      </b-card-header>

      <b-table
        :items="customerTypes"
        :fields="customerTypesFields"
        show-empty
        :empty-text="$t('common.no_data')"
      >
        <template #cell(actions)="row">
          <b-button
            variant="outline-primary"
            size="sm"
            class="mr-1"
            @click="openModal('edit', row.item)"
          >
            {{ $t('common.edit') }}
          </b-button>
          <b-button
            variant="outline-danger"
            size="sm"
            @click="openModal('delete', row.item)"
          >
            {{ $t('common.delete') }}
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Modal for Create/Edit -->
    <b-modal
      v-model="createEditModal"
      :title="modalTitle"
      no-close-on-backdrop
      @hidden="resetModal"
      @ok="handleSave"
    >
      <b-form @submit.prevent="handleSave">
        <b-form-group
          :label="$t('settings.customerType.fields.name')"
          label-for="customerType-name"
        >
          <b-form-input
            id="customerType-name"
            v-model="form.name"
            :placeholder="$t('settings.customerType.fields.name')"
            required
          />
        </b-form-group>
      </b-form>

      <template #modal-ok>
        {{ isEditMode ? $t('common.update') : $t('common.save') }}
      </template>
      <template #modal-cancel>
        {{ $t('common.cancel') }}
      </template>
    </b-modal>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      v-model="deleteModal"
      :title="$t('common.delete_confirmation')"
      variant="danger"
      @ok="handleDelete"
    >
      <p>{{ $t('settings.customerType.messages.confirm_delete_text') }} "{{ selectedItemName }}" ؟</p>

      <template #modal-ok>
        {{ $t('common.delete') }}
      </template>
      <template #modal-cancel>
        {{ $t('common.cancel') }}
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BCardHeader,
  BTable,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BCard,
    BButton,
    BCardHeader,
    BTable,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      createEditModal: false,
      deleteModal: false,
      isEditMode: false,
      selectedItem: null,
      form: {
        name: '',
      },
      customerTypesFields: [
        { key: 'name', label: this.$t('settings.customerType.fields.name') },
        { key: 'user.name', label: this.$t('settings.customerType.fields.added_by') },
        { key: 'actions', label: this.$t('settings.customerType.actions') },
      ],
    }
  },
  computed: {
    ...mapGetters({
      customerTypes: 'settings/customerTypes',
      loadCustomerTypes: 'settings/loadCustomerTypes',
    }),
    modalTitle() {
      return this.isEditMode
        ? this.$t('settings.customerType.actions.edit_attribute')
        : this.$t('settings.customerType.actions.add_attribute')
    },
    selectedItemName() {
      return this.selectedItem ? this.selectedItem.name : ''
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    openModal(action, item = null) {
      if (action === 'create') {
        this.isEditMode = false
        this.selectedItem = null
        this.resetForm()
        this.createEditModal = true
      } else if (action === 'edit') {
        this.isEditMode = true
        this.selectedItem = item
        this.form.name = item.name
        this.createEditModal = true
      } else if (action === 'delete') {
        this.selectedItem = item
        this.deleteModal = true
      }
    },

    async handleSave() {
      try {
        if (this.isEditMode) {
          // Update existing customer type
          await this.$store.dispatch('settings/updateCustomerType', {
            id: this.selectedItem.id,
            data: this.form,
          })
          this.$toast.success(this.$t('settings.customerType.messages.update_success'))
        } else {
          // Create new customer type
          await this.$store.dispatch('settings/addCustomerType', { query: this.form })
          this.$toast.success(this.$t('settings.customerType.messages.create_success'))
        }

        this.createEditModal = false
        this.resetForm()
        this.init() // Refresh the list
      } catch (error) {
        this.$toast.error(this.$t('settings.customerType.messages.error_occurred'))
        console.error('Error saving customer type:', error)
      }
    },

    async handleDelete() {
      try {
        await this.$store.dispatch('settings/deleteCustomerType', { id: this.selectedItem.id })
        this.$toast.success(this.$t('settings.customerType.messages.delete_success'))
        this.deleteModal = false
        this.init() // Refresh the list
      } catch (error) {
        this.$toast.error(this.$t('settings.customerType.messages.error_occurred'))
        console.error('Error deleting customer type:', error)
      }
    },

    resetForm() {
      this.form = {
        name: '',
      }
    },

    resetModal() {
      this.resetForm()
      this.selectedItem = null
      this.isEditMode = false
    },

    init() {
      this.$store.dispatch('settings/ListCustomerTypes')
    },
  },
}
</script>
